var Commentaries = function() {
    return {
        load: function(mid) {
            Ajax.loadCommentaries(mid, function(res) {
                if (res.success == 'ok') {
                    $('#commentaries' + mid).html(res.html);
                    if (Generic.mobile && !$('#commentary_typing_dots').length) {
                        // no longer in live mode, remove red dot
                        $('#commentary_live_dot').hide();
                    }
                } else {
                    location.reload();
                }
            });
        }
    };
}();

if (typeof module !== 'undefined') {
    module.exports = Commentaries;
}
